module.exports = __webpack_public_path__ + "media/images/ShoeRedCheckmark-ef1918db.svg";